import StrategyEdge from "./StrategyEdge";
export default StrategyEdge;